module.exports = __webpack_public_path__ + "static/media/should_we_farm_in_forests_tablet.c76db17e.jpg";